import dayjs from "dayjs";
import { useTenant } from "hooks/settings";
import { useGetScrapLoadingLayoutQuery } from "src/store/api/generatedApi";

/**
 * Hook to fetch the scrap loading layout for a location.
 * Used by pages to fetch layout once and pass to overlays/modals.
 *
 * @param location - The location to fetch layout for (default: "crane")
 */
export const useScrapLoadingLayout = (location = "crane") => {
  const tenantName = useTenant();

  // using now makes the query have different props every re-mount (so we can't cache it).
  // assuming it doesn't change often, let's peg it to start of day.
  const startOfDay = dayjs().startOf("day").toISOString();

  const { data: response, isLoading } = useGetScrapLoadingLayoutQuery({
    tenantName,
    timestamp: startOfDay,
    location,
  });
  const layoutResponse = response?.layout;

  if (layoutResponse == null) {
    return {
      layoutResponse: undefined,
      layout: undefined,
      layoutType: undefined,
      isLoading,
    };
  }

  if (layoutResponse.layout_type === "railcar") {
    return {
      layoutResponse,
      layout: layoutResponse.data,
      layoutType: "railcar" as const,
      isLoading: false,
    };
  }

  if (layoutResponse.layout_type === "grid") {
    return {
      layoutResponse,
      layout: layoutResponse.data,
      layoutType: "grid" as const,
      isLoading: false,
    };
  }

  return {
    layoutResponse,
    layout: layoutResponse.data,
    layoutType: layoutResponse.layout_type,
    isLoading: false,
  };
};
